import { ThemeSettings } from '../types/theme'
import api from './api'

export const getThemeSettings = async (paymentPageId: string): Promise<ThemeSettings> => {
    return await api('/api/payment-page/theme', { paymentPageId }) as ThemeSettings
}
